import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Inject, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService, DialogBase } from 't4core';
import { LocationInfo } from 't4core';



@Component({
  selector: 'dialog-impersonate',
  templateUrl: './impersonate.html',
  animations: [
      trigger('formState', [
          state('form', style({
              opacity: 1.0,
              display: 'block'
          })),
          state('success', style({
              opacity: 0,
              display: 'none'
          })),
          transition('success => visible', animate('200ms ease-in')),
          transition('visible => success', animate('200ms ease-out'))
      ]),
      trigger('successState', [
          state('success', style({
              opacity: 1.0,
              display: 'block'
          })),
          state('form', style({
              opacity: 0,
              display: 'none'
          })),
          transition('success => form', animate('200ms ease-in')),
          transition('form => success', animate('200ms ease-out'))
      ])
  ]
})
export class ImpersonateDialog extends DialogBase {

    @ViewChildren('locationItem', { read: ElementRef }) private locationItems: QueryList<ElementRef>;

    // <ViewModel>
    public isWorking: boolean = false;
    public state = "form";

    private locations: LocationInfo[];
    public filteredLocations: LocationInfo[];

    public selectedLocation: LocationInfo | null;

    public theForm: FormGroup; 
    // </ViewModel>

  constructor(
      public dialogRef: MatDialogRef<ImpersonateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {
      super("ImpersonationDialog");
      
      this.theForm = this.formBuilder.group({
          searchText: ['', Validators.required]
      });

      this.Api.get<LocationInfo[]>("Account/GetImpersonationOptions").then((x) => {
          this.locations = x.sort((x, y) => {
              if (x.Name == y.Name) return 0;
              if (x.Name < y.Name) return -1;
              else return 1;
          });

          this.updateFilter();
      });
    }


    // <Validation>
    
    // </Validation>

    // <Commands>
  public updateFilter() {
      if (!this.locations || this.locations.length === 0) {
          this.filteredLocations = [];
          this.selectedLocation = null;
          return;
      }

      var search = this.theForm.get("searchText")!.value.toLowerCase();
      var found = 0;
      var currentSelection = this.selectedLocation;

      if (search != "") {
          this.filteredLocations = this.locations.slice().filter((x, index) => {
              var ret = (found < 20) && (
                  (x.Name && x.Name.toLowerCase().indexOf(search) >= 0) ||
                  (x.LocationCode && x.LocationCode.toLowerCase().indexOf(search) >= 0) ||
                  (x.CustomerLocationId && x.CustomerLocationId.toLowerCase().indexOf(search) >= 0) ||
                  (x.Address && x.Address.toLowerCase().indexOf(search) >= 0) ||
                  (x.City && x.City.toLowerCase().indexOf(search) >= 0)
              );

              if (ret) found++;
              return ret;
          });

          if (this.filteredLocations.length > 0) {
              this.selectedLocation = currentSelection && this.filteredLocations.includes(currentSelection)
                  ? currentSelection
                  : this.filteredLocations[0];
              this.scrollSelectedLocationIntoView();
          } else {
              this.selectedLocation = null;
          }
      } else {
          this.filteredLocations = [];
          this.selectedLocation = null;
      }
  }

  public handleKeydown(event: KeyboardEvent) {
      if (this.isWorking || !this.filteredLocations || this.filteredLocations.length === 0) {
          if (event.key === "Enter") event.preventDefault();
          return;
      }

      if (event.key === "ArrowDown") {
          event.preventDefault();
          this.selectRelativeLocation(1);
      } else if (event.key === "ArrowUp") {
          event.preventDefault();
          this.selectRelativeLocation(-1);
      } else if (event.key === "Enter" && this.selectedLocation) {
          event.preventDefault();
          this.impersonate();
      }
  }

  public selectLocation(location: LocationInfo) {
      if (this.isWorking) return;

      this.selectedLocation = location;
      this.scrollSelectedLocationIntoView();
  }

  private selectRelativeLocation(step: number) {
      if (!this.filteredLocations || this.filteredLocations.length === 0) return;

      if (!this.selectedLocation) {
          this.selectedLocation = step > 0
              ? this.filteredLocations[0]
              : this.filteredLocations[this.filteredLocations.length - 1];
          this.scrollSelectedLocationIntoView();
          return;
      }

      var currentIndex = this.filteredLocations.indexOf(this.selectedLocation);
      if (currentIndex < 0) {
          this.selectedLocation = this.filteredLocations[0];
          this.scrollSelectedLocationIntoView();
          return;
      }

      var nextIndex = Math.max(0, Math.min(this.filteredLocations.length - 1, currentIndex + step));
      this.selectedLocation = this.filteredLocations[nextIndex];
      this.scrollSelectedLocationIntoView();
  }

  private scrollSelectedLocationIntoView() {
      setTimeout(() => {
          if (!this.selectedLocation || !this.locationItems) return;

          var selectedIndex = this.filteredLocations.indexOf(this.selectedLocation);
          if (selectedIndex < 0) return;

          var selectedItem = this.locationItems.toArray()[selectedIndex];
          if (selectedItem && selectedItem.nativeElement) {
              selectedItem.nativeElement.scrollIntoView({ block: 'nearest' });
          }
      });
  }

  public impersonate() {
      if (!this.selectedLocation) return;
      this.isWorking = true;

      this.authService.impersonate(this.selectedLocation.LocationCode + "_Admin").then(x => {
          this.state = "success";
          setTimeout(() => { this.dialogRef.close(); }, 1000);

          this.isWorking = false;
      });
    }
    // </Commands>

}
